// extracted by mini-css-extract-plugin
module.exports = {"ActionBar":"ApproverPendingLoan_ActionBar__18VyX","AggregatorSearch":"ApproverPendingLoan_AggregatorSearch__2Lnjv"};